import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchGitPullRequestCommits } from '@/services/git/api';
import type { GitCommit } from '@/services/git/types';
import { useAuthStoreV1 } from '@/stores/authStore_v1';

export function useGitPullRequestCommits(
  repoFullName: string | null | undefined,
  number: number | null | undefined,
): UseQueryResult<GitCommit[], Error> {
  const token = useAuthStoreV1((s) => s.token);
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id);

  return useQuery({
    queryKey: ['gitPullRequestCommits', orgId, repoFullName, number],
    queryFn: () => fetchGitPullRequestCommits(orgId!, repoFullName!, number!),
    enabled: !!token && !!orgId && !!repoFullName && number != null,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
